import SkeletonBlock from '@loaders/SkeletonBlock';
import OnboardingPageLayout from '@modules/merchant/authentication/components/OnboardingPageLayout';
import { memo } from 'react';

const META_ROW_COUNT = 4;

const BusinessDetailPageSkeleton = memo(() => (
  <OnboardingPageLayout>
    <div
      className="flex w-full flex-col gap-form"
      aria-busy="true"
      aria-label="Loading business details"
    >
      <div className="flex w-full items-center gap-1.5 py-2.5 desktop:gap-2 desktop:py-3">
        <SkeletonBlock className="icon-md shrink-0 rounded" />
        <SkeletonBlock className="h-5 w-24 rounded" />
      </div>

      <div className="flex w-full flex-col gap-page">
        <SkeletonBlock className="h-[132px] w-full rounded md:h-[165px] md:rounded-[6px] desktop:h-[220px] desktop:rounded-lg" />

        <div className="flex w-full flex-col gap-business-detail-section">
          <SkeletonBlock className="h-6 w-3/4 max-w-sm rounded desktop:h-8" />

          <div className="flex w-full flex-col gap-business-results">
            {Array.from({ length: META_ROW_COUNT }, (_, index) => (
              <div
                key={`business-detail-meta-skeleton-${index}`}
                className="flex w-full items-center gap-business-result-row"
              >
                <SkeletonBlock className="icon-sm shrink-0 rounded" />
                <SkeletonBlock
                  className={`h-4.5 rounded desktop:h-6 ${index % 2 === 0 ? 'w-40 max-w-full' : 'w-56 max-w-full'}`}
                />
              </div>
            ))}
          </div>

          <div className="flex w-full flex-col gap-0.75 desktop:gap-1">
            <SkeletonBlock className="h-4.5 w-16 rounded desktop:h-6" />
            <SkeletonBlock className="h-4.5 w-full rounded desktop:h-6" />
            <SkeletonBlock className="h-4.5 w-4/5 rounded desktop:h-6" />
          </div>
        </div>

        <div className="flex w-full gap-business-actions">
          <SkeletonBlock className="min-h-8 flex-1 rounded-full desktop:min-h-11" />
          <SkeletonBlock className="min-h-8 flex-1 rounded-full desktop:min-h-11" />
        </div>
      </div>
    </div>
  </OnboardingPageLayout>
));

BusinessDetailPageSkeleton.displayName = 'BusinessDetailPageSkeleton';

export default BusinessDetailPageSkeleton;
